/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { fireEvent } from '@testing-library/preact';
import { expect } from 'chai';

type Callback = {
  startCalled: boolean;
  enterCalled: boolean;
  overCalled: boolean;
  dropCalled: boolean;
  dragDetailCorrect: boolean;
  dropDetailCorrect: boolean;
};

export function getDndCallbacks(
  callbacks: Callback,
  dragStartCallback: (detail: any) => void,
  dropCallback: (detail: any) => boolean
) {
  return {
    onDragStart: (detail: any) => {
      callbacks.startCalled = true;
      dragStartCallback(detail);
    },
    onDragEnter: (detail: any) => {
      if (detail.event) {
        callbacks.enterCalled = true;
        detail.event.preventDefault();
      }
    },
    onDragOver: (detail: any) => {
      callbacks.overCalled = true;
      const accept = dropCallback(detail);
      if (accept) detail.event.preventDefault();
    },
    onDrop: (detail: any) => {
      callbacks.dropCalled = true;
      dropCallback(detail);
    }
  };
}

export function testDnd(
  dragTarget: Element,
  dropTarget: Element,
  feedbackTarget: Element,
  callbacks: Callback,
  isSVG: boolean,
  dropOptions?: any,
  rejected?: boolean
) {
  fireEvent.dragStart(dragTarget);
  fireEvent.dragEnter(dropTarget, dropOptions);
  fireEvent.dragOver(dropTarget, dropOptions);
  const styles = window.getComputedStyle(feedbackTarget);
  const fill = styles.getPropertyValue(isSVG ? 'fill' : 'background-color');
  expect(fill).to.be.equal(rejected ? 'rgba(0, 0, 0, 0)' : 'rgb(208, 229, 238)');
  const cursor = styles.getPropertyValue('cursor');
  expect(cursor).to.be.equal(rejected ? 'no-drop' : 'auto');
  fireEvent.drop(dropTarget, dropOptions);
  expect(callbacks.dragDetailCorrect).to.be.true;
  expect(callbacks.startCalled).to.be.true;
  expect(callbacks.enterCalled).to.be.true;
  expect(callbacks.overCalled).to.be.true;
  expect(callbacks.dropCalled).to.be.true;
  if (rejected) {
    expect(callbacks.dropDetailCorrect).to.be.false;
  } else {
    expect(callbacks.dropDetailCorrect).to.be.true;
  }
}
